<main
  id="main_modal_content_terms"
  class="bg-white rounded-xl shadow-xl w-full max-w-full overflow-x-hidden overflow-y-hidden border border-neutral-200 flex flex-col"
>
  <header
    id="header"
    class="flex justify-between items-center p-6 border-b border-neutral-200 bg-neutral-50"
  >
    <div class="flex items-center space-x-3 min-w-0">
      <div
        class="w-10 h-10 bg-neutral-800 rounded-lg flex items-center justify-center flex-shrink-0"
      >
        <i class="fa-solid fa-file-contract text-white text-lg"></i>
      </div>
      <div class="min-w-0">
        <h1 class="text-lg text-neutral-900 break-words whitespace-normal">
          Termos e Condições
        </h1>
        <p class="text-sm text-neutral-500 break-words whitespace-normal">
          Última atualização: Janeiro 2025
        </p>
      </div>
    </div>
    <button
      id="close_button_terms"
      aria-label="Close modal"
      class="text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100 rounded-full p-2 transition-all duration-200 flex-shrink-0"
    >
      <i class="fa-solid fa-xmark fa-lg"></i>
    </button>
  </header>

  <section id="terms_content_section" class="flex-grow overflow-y-auto min-w-0">
    <div class="p-8 space-y-8 max-w-full">
      <div id="acceptance_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">1</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Aceitação dos Termos
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          Ao utilizar a plataforma [NOME DA SUA PLATAFORMA] ("Plataforma"), o
          usuário declara que leu, entendeu e concorda com estes Termos e
          Condições, bem como com a Política de Privacidade disponível em
          [LINK]. Caso não concorde, o uso da Plataforma deve ser imediatamente
          interrompido.
        </p>
      </div>

      <div id="object_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">2</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Objeto
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          A Plataforma oferece ferramentas para automação e gestão de
          comunicação comercial através da API oficial do WhatsApp, visando
          auxiliar empresas e profissionais no crescimento de suas vendas,
          respeitando integralmente as políticas e requisitos da Meta Platforms,
          Inc.
        </p>
      </div>

      <div id="responsibilities_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">3</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Responsabilidades do Usuário
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 mb-3 break-words whitespace-normal">
          O usuário é o único responsável por:
        </p>
        <div class="pl-11 space-y-2">
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              Garantir que possui autorização dos destinatários para o
              recebimento das mensagens;
            </p>
          </div>
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              Assegurar a veracidade e legalidade das informações e listas de
              contatos utilizadas;
            </p>
          </div>
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              Não utilizar a Plataforma para envio de mensagens não solicitadas
              ("SPAM") ou em desacordo com as políticas da Meta;
            </p>
          </div>
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              Arcar com qualquer consequência decorrente do uso indevido da
              Plataforma.
            </p>
          </div>
        </div>
        <div
          class="pl-11 mt-4 p-4 bg-neutral-50 rounded-lg border border-neutral-200"
        >
          <p class="text-sm text-neutral-700 break-words whitespace-normal">
            O descumprimento destas responsabilidades poderá resultar na
            suspensão ou cancelamento imediato da conta, sem qualquer obrigação
            de reembolso.
          </p>
        </div>
      </div>

      <div id="limitations_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">4</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Limitações Técnicas e Ausência de Garantia
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 mb-3 break-words whitespace-normal">
          A Plataforma realiza o envio de mensagens exclusivamente por meio de
          integração com a API oficial do WhatsApp. O usuário reconhece e
          concorda que:
        </p>
        <div class="pl-11 space-y-3">
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              Podem ocorrer falhas, atrasos, duplicações ou não entrega de
              mensagens por fatores externos ao controle da Plataforma;
            </p>
          </div>
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              Em casos de falha de comunicação com a API, o sistema poderá
              realizar novas tentativas automáticas de envio;
            </p>
          </div>
          <div class="flex items-start space-x-2 min-w-0">
            <div class="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
            <p class="text-sm text-neutral-700 break-words whitespace-normal">
              A Plataforma não garante a entrega de 100% das mensagens enviadas;
            </p>
          </div>
        </div>
      </div>

      <div id="blocking_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">5</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Bloqueio de Número e Sanções da Meta
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          A Plataforma não se responsabiliza por eventuais bloqueios, suspensões
          ou restrições aplicadas pela Meta ou pelo WhatsApp ao número utilizado
          pelo usuário.
        </p>
      </div>

      <div id="liability_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">6</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Isenção de Responsabilidade
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          Em hipótese alguma a Plataforma será responsável por danos diretos,
          indiretos, incidentais, especiais ou consequenciais decorrentes do uso
          da Plataforma.
        </p>
      </div>

      <div id="indemnification_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">7</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Indenização Reversa
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          O usuário concorda em indenizar, defender e isentar a Plataforma de
          quaisquer reclamações relacionadas ao uso inadequado da Plataforma.
        </p>
      </div>

      <div id="changes_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">8</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Alterações
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          A Plataforma poderá alterar estes Termos a qualquer momento, mediante
          publicação da versão atualizada.
        </p>
      </div>

      <div id="jurisdiction_section" class="space-y-4">
        <div class="flex items-center space-x-3 mb-4 min-w-0">
          <div
            class="w-8 h-8 bg-neutral-100 rounded-lg flex items-center justify-center flex-shrink-0"
          >
            <span class="text-sm text-neutral-700">9</span>
          </div>
          <h2 class="text-lg text-neutral-900 break-words whitespace-normal">
            Foro
          </h2>
        </div>
        <p class="text-sm text-neutral-700 leading-relaxed pl-11 break-words whitespace-normal">
          Fica eleito o foro da Comarca de [CIDADE/UF], com renúncia expressa de
          qualquer outro, por mais privilegiado que seja.
        </p>
      </div>
    </div>
  </section>
</main>